import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import './App.css';
import Layout from "./commonComponents/Layout";
import Login from "./components/Login";
import BrandForm from "./commonComponents/BrandForm";
import CategoryForm from "./commonComponents/CategoryForm";


// Lazy Load Components
const Dashboard = React.lazy(() => import("./components/Dashboard"));
const Projects = React.lazy(() => import("./components/Projects"));
const Unicode = React.lazy(() => import("./components/Unicode"));
const Playables = React.lazy(() => import("./components/Playables"));
const CreatePlayable = React.lazy(() => import("./components/CreatePlayable"));
const EditPlayable = React.lazy(() => import("./components/EditPlayable"));
const PlayableUnicodes = React.lazy(() => import("./components/PlayableUnicodes"));
const CreateProject = React.lazy(() => import("./components/CreateProject"));

const StaticPlayable = React.lazy(() => import("./components/staticPlayable/StaticPlayable"));
const StaticPlayableDashboard = React.lazy(() => import("./components/staticPlayable/StaticPlayableDashboard"));
const EditStaticPlayable = React.lazy(() => import("./components/staticPlayable/EditStaticPlayable"));
const CreateStaticPlayable = React.lazy(() => import("./components/staticPlayable/CreateStaticPlayable"));

const Industries = React.lazy(() => import("./components/industries/Industries"));
const EditIndustries = React.lazy(() => import("./components/industries/EditIndustries"));
const CreateIndustries = React.lazy(() => import("./components/industries/CreateIndustries"));

const GameCategories = React.lazy(() => import("./components/gamecategories/GameCategories"));


const Brand = React.lazy(() => import("./components/brand/Brand"));




function App() {

  useEffect(() => {
    const checkAuth = () => {
      const loginTime = localStorage.getItem("loginTime");
      if (loginTime) {
        const expiry = 2 * 60 * 60 * 1000; // 2 hours
        if (Date.now() - loginTime > expiry) {
          localStorage.clear();
          window.location.href = "/";
        }
      }
    };
    const interval = setInterval(checkAuth, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <Router>
        <Suspense fallback={<div className="loader-container"><div className="loader"></div></div>}>
          <Routes>
            <Route path="/" element={<Login />} />

            <Route element={<Layout />}>
              {/* <Route path="/dashboard" element={<Dashboard />} />

              <Route path="/playables" element={<Playables />} />
              <Route path="/playables/create" element={<CreatePlayable />} />
              <Route path="/playables/edit" element={<EditPlayable />} />
              <Route path="/playables/unicodes" element={<PlayableUnicodes />} />

              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/create" element={<CreateProject />} />
              <Route path="/unicodes" element={<Unicode />} /> */}


              <Route path="/staticplayabledashboard" element={<StaticPlayableDashboard />} />
              <Route path="/staticplayable" element={<StaticPlayable />} />
              <Route path="/staticplayable/create" element={<CreateStaticPlayable />} />
              <Route path="/staticplayable/edit" element={<EditStaticPlayable />} />

              <Route path="/brand" element={<Brand />} />
              <Route path="/brand/create" element={<BrandForm />} />
              <Route path="/brand/edit" element={<BrandForm />} />

              <Route path="/industries" element={<Industries />} />
              <Route path="/industries/create" element={<CreateIndustries />} />
              <Route path="/industries/edit" element={<EditIndustries />} />

              <Route path="/gamecategories" element={<GameCategories />} />
              <Route path="/gamecategories/create" element={<CategoryForm />} />
              <Route path="/gamecategories/edit" element={<CategoryForm />} />



            </Route>

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;